/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import Popup from "../../snackbar/popup";

const PrivacyPolicyCookie = () => {

  return (
    <React.Fragment>
      <section className="bg-half bg-light min-vh-100">
        <Container>
          <h3 className="title mb-5 fw-bold text-center">
            Privacy- en cookieverklaring
          </h3>
          <p className="text-muted" >
            Het platform Werkenindezwembadbranche is eigendom van het arbeidsmarktplatform Werkenindezwembadbranche.nl. Het beheer en de uitvoering van het platform liggen geheel bij Werkenindezwembadbranche. Werkenindezwembadbranche is derhalve verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.
          </p>
          <h5 className="title mb-1 fw-bold">
            Contactgegevens:
          </h5>
          <p className="text-muted" >
            Voor vragen over ons privacybeleid kunt u contact opnemen via: <br />
            <strong className="text-dark" >
              <Link to={'https://werkenindezwembadbranche.nl'} >werkenindezwembranche.nl</Link></strong> <br />
            <strong className="text-dark" > E-mail: <Link to={'mailTo:support@werkenindezwembadbranche.nl'} >support@werkenindezwembadbranche.nl</Link> </strong>
          </p>
          <h5 className="title mb-1 fw-bold">
            Persoonsgegevens die wij verwerken
          </h5>
          <p className="text-muted mb-0" >
            Werkenindezwembadbranche verwerkt je persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze gegevens zelf aan ons verstrekt. Hieronder vind je een overzicht van de persoonsgegevens die wij verwerken:
          </p>
          <ul className="text-muted" >
            <li>Voor- en achternaam</li>
            <li>Telefoonnummer (indien opgegeven)</li>
            <li>E-mailadres</li>
          </ul>
          <h5 className="title mb-1 fw-bold">
            Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken
          </h5>
          <p className="text-muted mb-0" >
            Werkenindezwembadbranche verwerkt jouw persoonsgegevens voor de volgende doelen:
          </p>
          <ul  className="text-muted" >
            <li>Het afhandelen van jouw betaling</li>
            <li>Verzenden van onze nieuwsbrief en/of reclamefolder</li>
            <li>Je te kunnen bellen of e-mailen indien dit nodig is om onze dienstverlening uit te kunnen voeren</li>
            <li>Je te informeren over wijzigingen van onze diensten en producten</li>
            <li>Je de mogelijkheid te bieden een account aan te maken</li>
            <li>Om goederen en diensten bij je af te leveren</li>
          </ul>
          <h5 className="title mb-1 fw-bold">
            Geautomatiseerde besluitvorming
          </h5>
          <p className="text-muted " >
            Werkenindezwembadbranche neemt op basis van geautomatiseerde verwerkingen besluiten over zaken die (aanzienlijke) gevolgen kunnen hebben voor personen. Het gaat hier om besluiten die worden genomen door computerprogramma’s of -systemen, zonder dat daar een mens (bijvoorbeeld een medewerker van Werkenindezwembadbranche) tussen zit.
          </p>

          <h5 className="title mb-1 fw-bold">
            Hoe lang we persoonsgegevens bewaren
          </h5>
          <p className="text-muted " >
            Werkenindezwembadbranche bewaart je persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor je gegevens worden verzameld. Jouw persoonsgegevens worden bewaard zolang jij een actief account hebt en/of vacatures online hebt staan op de website.
          </p>


          <h5 className="title mb-1 fw-bold">
            Delen van persoonsgegevens met derden
          </h5>
          <p className="text-muted " >
            Werkenindezwembadbranche verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met jou of om te voldoen aan een wettelijke verplichting.
          </p>


          <h5 className="title mb-1 fw-bold">
            Cookies, of vergelijkbare technieken, die wij gebruiken
          </h5>
          <p className="text-muted " >
            Werkenindezwembadbranche gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van je computer, tablet of smartphone. Werkenindezwembadbranche gebruikt cookies met een puur technische functionaliteit. Deze zorgen ervoor dat de website naar behoren werkt en dat bijvoorbeeld jouw voorkeursinstellingen onthouden worden. Deze cookies worden ook gebruikt om de website goed te laten werken en deze te kunnen optimaliseren. Daarnaast plaatsen we cookies die jouw surfgedrag bijhouden zodat we op maat gemaakte content en advertenties kunnen aanbieden. Bij jouw eerste bezoek aan onze website hebben wij je al geïnformeerd over deze cookies en hebben we je toestemming gevraagd voor het plaatsen ervan. Je kunt je afmelden voor cookies door je internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kun je ook alle informatie die eerder is opgeslagen via de instellingen van je browser verwijderen. Zie voor een toelichting: <Link to={'https://veiliginternetten.nl'} target="_blank" >https://veiliginternetten.nl</Link> .
          </p>


          <h5 className="title mb-1 fw-bold">
            Gegevens inzien, aanpassen of verwijderen
          </h5>
          <p className="text-muted " >
            Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te verwijderen. Dit kun je zelf doen via de persoonlijke instellingen van jouw account. Daarnaast heb je het recht om je eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van jouw persoonsgegevens door ons bedrijf en heb je het recht op gegevensoverdraagbaarheid. Dat betekent dat je bij ons een verzoek kan indienen om de persoonsgegevens die wij van jou beschikken in een computerbestand naar jou of een ander, door jou genoemde organisatie, te sturen. Wil je gebruik maken van je recht op bezwaar en/of recht op gegevensoverdraagbaarheid of heb je andere vragen/opmerkingen over de gegevensverwerking, stuur dan een gespecificeerd verzoek naar support@werkenindezwembadbranche.nl. Om er zeker van te zijn dat het verzoek tot inzage door jou is gedaan, vragen wij jou een kopie van je identiteitsbewijs bij het verzoek mee te sturen. Maak in deze kopie je pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van je privacy. Werkenindezwembadbranche zal zo snel mogelijk, maar in ieder geval binnen vier weken, op jouw verzoek reageren. Werkenindezwembadbranche wil je er tevens op wijzen dat je de mogelijkheid hebt om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link: <Link to={'https://autoriteitpersoonsgegevens.nl'} target="_blank" >https://autoriteitpersoonsgegevens.nl</Link> .
          </p>

          <h5 className="title mb-1 fw-bold">
            Hoe wij persoonsgegevens beveiligen
          </h5>
          <p className="text-muted " >
            Werkenindezwembadbranche neemt de bescherming van jouw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als jij het idee hebt dat jouw gegevens toch niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op met onze klantenservice of via <Link to={'mailTo:support@werkenindezwembadbranche.nl'} >support@werkenindezwembadbranche.nl</Link> .
          </p>
        </Container>
        <Popup />
      </section>
    </React.Fragment>
  );
}
export default PrivacyPolicyCookie
